angular.module('TetherApp').factory('locationService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let deleteLocation = function (locationId) {
            let uri = '/location/' + locationId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let listNearbyLocationsForLinkLocation = function (linkLocationId) {
            let uri = '/link-location/' + linkLocationId + '/nearby';

            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let linkLocationAttach = function (locationId, linkLocationId) {
            let uri = '/location/' + locationId + '/link-location/' + linkLocationId + '/attach';

            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let linkLocationDetach = function (locationId, linkLocationId) {
            let uri = '/location/' + locationId + '/link-location/' + linkLocationId + '/detach';

            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let createLocationAndAttachLinkLocation = function (data) {
            let uri = '/location/create-location-and-attach-link-location';

            return $http.post(
                uri,
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let setLinkLocationNotAttributable = function (linkLocationId) {
            let uri = '/link-location/'
                + linkLocationId
                + '/set-not-attributable';

            return $http.post(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let setLinkLocationAttributable = function (linkLocationId) {
            let uri = '/link-location/'
                + linkLocationId
                + '/set-attributable';

            return $http.post(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            deleteLocation: deleteLocation,
            listNearbyLocationsForLinkLocation: listNearbyLocationsForLinkLocation,
            linkLocationAttach: linkLocationAttach,
            linkLocationDetach: linkLocationDetach,
            createLocationAndAttachLinkLocation : createLocationAndAttachLinkLocation,
            setLinkLocationNotAttributable: setLinkLocationNotAttributable,
            setLinkLocationAttributable: setLinkLocationAttributable
        }
    }
]);
